import React, { useContext } from "react";
import { Link } from "react-router-dom";
import noteContext from "../context/notes/noteContext";

const NotesItem = (props) => {
  const context = useContext(noteContext);
  const {deleteNote} = context;
  let {count, title, description, tag, noteId } = props;

  return (
    <>
      <tr className="text-center align-middle">
        <th scope="row" className="border">
          {count}
        </th>
        <td className="border" style={{maxWidth: '100px'}}>{title}</td>
        <td className="border" style={{maxWidth: '180px'}}>{description}</td>
        <td className="border" style={{maxWidth: '100px'}}>{tag}</td>
        <td className="border" style={{maxWidth: '120px'}}>
          <Link to={`/editnote?noteId=${noteId}&&title=${title}&&description=${description}&&tag=${tag}`}>
            <button className="btn btn-primary mx-2 my-1">
              Edit <i className="uil uil-edit"></i>
            </button>
          </Link>
            <button className="btn btn-danger mx-2 my-1" onClick={()=>{deleteNote(noteId); props.showAlert('success', 'Success', "Note Deleted Successfully")}}>
              Delete <i className="uil uil-trash-alt"></i>
            </button>
        </td>
      </tr>
    </>
  );
};

export default NotesItem;
